// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_sticky-notifications_154bi_ivos2_9:not(#\\9 ){position:sticky;z-index:850}.awsui_sticky-notifications-with-background_154bi_ivos2_13:not(#\\9 ){background-color:var(--color-background-layout-main-taq3m8, #f2f3f3)}.awsui_has-notifications-content_154bi_ivos2_17:not(#\\9 ){padding-block-start:var(--space-scaled-xs-urwryp, 8px)}", ""]);
// Exports
module.exports = exports;
